"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var naMatcher = /^(none|nan?|null|n\/a|unavailable|undefined)$/i;
exports.isNaLike = function (val) {
    if (typeof val === "string") {
        return !(val.trim()) || !!(val.trim().match(naMatcher));
    }
    if ((typeof val).match(/number|boolean/)) {
        return false;
    }
    return !val;
};
